import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

import CanvasContainer from '../containers/canvas-container';
import ClaimedDomainsContainer from '../../system/claimed-domains/claimed-domains-container';
import DiscoveredDomainsContainer from '../../system/discovered-domains/discovered-domains-container';
import CollectionOverviewContainer from '../containers/collection-overview-container';
import CollectionTabs from '../../common/components/collection-tabs';

const styles = theme => ( {
    content: {
        backgroundColor: theme.palette.background.paper,
        height: '100%',
        padding: theme.spacing.unit * 2,
    },
} );

const Collection = ( {
    activeCollectionTabIndex,
    classes,
    collectionTabItems,
    isEditMode,
    handleSwitchCollectionTab,
    match
} ) => {
    return (
        <>
            {
                !isEditMode &&
                ( <CollectionTabs
                    activeCollectionTabIndex={activeCollectionTabIndex}
                    collectionTabItems={collectionTabItems}
                    handleSwitchCollectionTab={handleSwitchCollectionTab}
                    match={match}
                /> )
            }
            <div className={classes.content}>
                <Switch>
                    <Route
                        exact
                        path={`${match.path}/:collectionId/claimed-domains`}
                        component={ClaimedDomainsContainer}
                    />
                    <Route
                        exact
                        path={`${match.path}/:collectionId/discovered-domains`}
                        component={DiscoveredDomainsContainer}
                    />
                    <Route
                        exact
                        path={`${match.path}/:collectionId/canvas/:canvasId`}
                        component={CanvasContainer}
                    />
                    <Route
                        exact
                        path={`${match.path}/:collectionId`}
                        component={CollectionOverviewContainer}
                    />
                </Switch>
            </div>
        </>
    );

};

Collection.propTypes = {
    activeCollectionTabIndex: PropTypes.number.isRequired,
    classes: PropTypes.object.isRequired,
    collectionTabItems: PropTypes.array.isRequired,
    handleSwitchCollectionTab: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool.isRequired,
    match: PropTypes.shape( {
        url: PropTypes.string
    } ),
};

export default withStyles( styles )( Collection );
